import { render, staticRenderFns } from "./emailCampaignsList.vue?vue&type=template&id=25c4d336"
import script from "./emailCampaignsList.vue?vue&type=script&lang=js"
export * from "./emailCampaignsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports